import React from 'react';
import {PayrollExplanationContainer, PayrollExplanationImage, PayrollExplanationText} from "./styles";

import { ReactComponent as RobotAction } from '../../../../assets/images/robot_holding_report.svg';
import { ReactComponent as RobotNoAction } from '../../../../assets/images/robot.svg';
import {Payroll, PayrollStatus} from "../../../../app/interfaces";
import {
    PAYROLL_STATUS_BONUS_PROVIDED,
    PAYROLL_STATUS_EOR_PARTNER_PAID, PAYROLL_STATUS_PAID,
    PAYROLL_STATUS_PENDING_BONUS,
    PAYROLL_STATUS_PENDING_COMPANY_PAYMENT,
    PAYROLL_STATUS_PENDING_EOR_PARTNER_PAYMENT,
    PAYROLL_STATUS_PENDING_PAYSLIP,
    PAYROLL_STATUS_PREPARING
} from "../../../../utils/constants";
import {useTranslation} from "react-i18next";
export const PayrollStatusExplanation = ({payroll}: { payroll: Payroll }) => {

    const {t} = useTranslation();
    const payrollStatusMessage = (status: PayrollStatus) => {
        switch (status){
            case PAYROLL_STATUS_PENDING_BONUS: return {
                title: t('pending_bonus_explanation_title') as string,
                subject: t('pending_bonus_explanation_message') as string,
                actionRequired: false
            }
            case PAYROLL_STATUS_BONUS_PROVIDED: return {
                title: t('bonus_provided_explanation_title') as string,
                subject: t('bonus_provided_explanation_message') as string,
                actionRequired: true
            }
            case PAYROLL_STATUS_PREPARING: return {
                title: t('preparing_payroll_title') as string,
                subject: t('preparing_payroll_message') as string,
                actionRequired: true
            }
            case PAYROLL_STATUS_PENDING_COMPANY_PAYMENT: return {
                title: t('pending_company_payment_explanation_title') as string,
                subject: t('pending_company_payment_explanation_message') as string,
                actionRequired: true
            }
            case PAYROLL_STATUS_PENDING_EOR_PARTNER_PAYMENT: return {
                title: t('pending_eor_partner_payment_explanation_title') as string,
                subject: t('pending_eor_partner_payment_explanation_message') as string,
                actionRequired: true
            }
            case PAYROLL_STATUS_EOR_PARTNER_PAID: return {
                title: t('employee_paid_explanation_title') as string,
                subject: t('employee_paid_explanation_subject') as string,
                actionRequired: true
            }
            case PAYROLL_STATUS_PENDING_PAYSLIP: return {
                title: t('pending_payslip_explanation_title') as string,
                subject: t('pending_payslip_explanation_message') as string,
                actionRequired: true
            }
            case PAYROLL_STATUS_PAID: return {
                title: t('paid_explanation_title') as string,
                subject: t('paid_explanation_message') as string,
                actionRequired: false
            }
            default: return {
                title: '',
                subject: '',
                actionRequired: false
            }
        }
    }
    
    const message = payrollStatusMessage(payroll.status);

    return <PayrollExplanationContainer actionRequired={message.actionRequired}>
        <PayrollExplanationText>
            <h1>{message.title}</h1>
            <h2>{message.subject}</h2>
        </PayrollExplanationText>
        <PayrollExplanationImage>
            {message.actionRequired ? <RobotAction/> : <RobotNoAction/>}
        </PayrollExplanationImage>
    </PayrollExplanationContainer>

}

export default PayrollStatusExplanation;
